<template>
	<div class="admin__download">
		<button class="admin__download__button btn" @click="download()">
			{{ status }}
			<Spinner v-if="downloadStarted" :size="20" :color="color"></Spinner>
		</button>
	</div>
</template>

<script>
import { saveAs } from "file-saver";
import url from "../../utils/apiUrl";

export default {
	data() {
		return {
			status: "Pobierz wszystkie media",
			color: "#000",
			downloadStarted: false,
		};
	},
	methods: {
		download() {
			this.status = "Przygotowuję plik";
			this.downloadStarted = true;

			fetch(`${url()}/posts/getCopy`, {
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Authorization: localStorage.getItem("token"),
				},
				responseType: "blob",
			})
				.then((res) => {
					this.status = "Pobieram plik";
					return res.blob();
				})
				.then((blob) => {
					this.downloadStarted = false;
					this.status = "Plik zapisany";
					saveAs(blob, `wojtagram-archiwum-${Date.now()}.zip`);
				});
		},
	},
};
</script>
